import { getRectOfNodes, getTransformForBounds, useReactFlow, useStore } from 'reactflow';
import { toPng, toBlob } from 'html-to-image';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCamera, faDownload } from '@fortawesome/free-solid-svg-icons';
import { useState } from 'react';
import Loader from './loaders/Loader';

const TakeSnapshot =  ({diagramName, className, text, ...rest}) => {
    const storeNodes = useStore((state) => Array.from(state.nodeInternals.values()));
    const [isDownloading, setIsDownloading] = useState(false);
    const takeShot = async () => {
        setIsDownloading(true);
        try {
            console.log("diagramName", diagramName)
            const viewport = document.querySelector('.react-flow__viewport');
            if (!viewport) return;

            const edgePaths = document.querySelectorAll('.react-flow__edge-path');
            const originalStrokes = [];
            edgePaths.forEach((path, i) => {
                originalStrokes[i] = path.style.stroke;
                path.style.stroke = '#000000';
                path.style.strokeWidth = '2px';
            });

            const nodesBounds = getRectOfNodes(storeNodes);
            const paddingX = 50;
            const width = nodesBounds.width + paddingX * 2;
            const height = nodesBounds.height + paddingX * 2;

            const [x, y, zoom] = getTransformForBounds(
                nodesBounds,
                width,
                height,
                0.1,
                4,
            );

            const pixelRatio = window.devicePixelRatio * 3
            const blob = await toBlob(viewport, {
                backgroundColor: '#ffffff',
                width,
                height,
                pixelRatio,
                cacheBust: true,
                style: {
                    width: `${width}px`,
                    height: `${height}px`,
                    transformOrigin: 'center center',
                    transform: `translate(${x}px, ${y}px) scale(${zoom})`,
                },
            });

            edgePaths.forEach((path, i) => {
                path.style.stroke = originalStrokes[i];
            });

            const timeStamp = new Date().toISOString().replace(/[:.]/g, '-');
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = diagramName ? `${diagramName}-${timeStamp}.png` : `diagram-snapshot-${timeStamp}.png`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url); // clean up so repeated downloads work
        } catch (e) {
            console.error('snapshot error:', e);
        } finally {
            setIsDownloading(false);
        }
    };

    return (
        <button onClick={takeShot} disabled={isDownloading} 
            className={className ?? 'hover:scale-110 px-5 py-1 cursor-pointer border border-blue-700 hover:border-blue-800 shadow-lg text-white hover:bg-blue-800 duration-200 rounded-lg bg-blue-700 text-black spacing-2'}
            {...rest}
        >
            {isDownloading ? (
                <>
                <Loader animationName={'loader'} height={30} width={30} className="text-white" />
                </>
            ) : (
                <>
                <FontAwesomeIcon icon={faDownload} /> {text}
                </>
            )}
        </button>
    );
}

export default TakeSnapshot